/**
 * @description base64加密处理
 * @param {string} str 需要加密的字符串
 * @returns {string} 加密后的字符串
 */
export function encryptStr (str) {
  return window.btoa(
    encodeURIComponent(str)
  )
}

/**
 * @description base64解密处理
 * @param {string} str 需要解密的字符串
 * @returns {string} 解密后的字符串
 */
export function decryptStr (str) {
  return decodeURIComponent(
    window.atob(str)
  )
}
